module.exports = __webpack_public_path__ + "img/Networking.fa9e751f.png";